import http from '../http';

/**
 * 원료 특성 마스터 목록 조회
 * @param {Object} params - 검색 조건 (material, currentPage, pageSize)
 * @returns {Promise} API 응답
 */
export const materialPropertyList = params => {
  return http.post('/api/v1/rawmaterial/list', params);
};

/**
 * 원료 특성 마스터 상세 조회
 * @param {string} material - 원료명
 * @returns {Promise} API 응답
 */
export const materialPropertyDetail = material => {
  return http.get(`/api/v1/rawmaterial/${material}`);
};

/**
 * 원료 특성 마스터 등록
 * @param {Object} data - 등록할 원료 특성 데이터
 * @returns {Promise} API 응답
 */
export const materialPropertyInsert = data => {
  return http.post('/api/v1/rawmaterial', data);
};

/**
 * 원료 특성 마스터 수정
 * @param {string} currentMaterial - 현재 원료명
 * @param {Object} data - 수정할 원료 특성 데이터
 * @returns {Promise} API 응답
 */
export const materialPropertyUpdate = (currentMaterial, data) => {
  return http.put(`/api/v1/rawmaterial/${currentMaterial}`, data);
};

/**
 * 원료 특성 마스터 삭제
 * @param {string} material - 원료명
 * @returns {Promise} API 응답
 */
export const materialPropertyDelete = material => {
  return http.delete(`/api/v1/rawmaterial/${material}`);
};

/**
 * 카테고리 목록 조회
 * @returns {Promise} API 응답
 */
export const getCategoryList = () => {
  return http.get('/api/v1/rawmaterial/categories');
};

/**
 * 원료 특성 마스터 이력 조회
 * @param {Object} params - 검색 조건 (material, currentPage, pageSize)
 * @returns {Promise} API 응답
 */
export const getRawMaterialHistory = params => {
  return http.post('/api/v1/rawmaterial/history', params);
};
